<!--<pre>{{data | json}}</pre>-->

<!--<ng-container *ngFor="let teaser of data.brandTeaser; let index = index">-->

<!--  <p>{{teaser.description}}</p>-->
<!--  <p>{{teaser.image.url}}</p>-->

<!--</ng-container>-->

<ng-container *transloco="let t; scope: 'cms'">
  <section class="portfolio default-padding block margin--bottom-l margin--top-l">
    <div class="default-max-width centered">
      <div class="layout-section-header">
        <div class="layout-section-header-main">
          <h3 class="headline-second">{{ data.title }}</h3>
        </div>

        <div class="layout-section-header-aside">
          <a href="{{ data.link }}">{{ t("cms.ui-portoflio.portfolio.read-more") }} <i class="icon-arrow-6"></i></a>
        </div>
      </div>

      <ngx-masonry *ngIf="masonryOptions" [ordered]="ordered" [options]="masonryOptions" class="layout-masonry-grid js-masonry-layout">
        <div
          ngxMasonryItem
          *ngFor="let teaser of data.brandTeaser; let index = index"
          class="layout-masonry-grid-item {{ index | masonryGridClass }}"
        >
          <div class="masonry-grid-tile">
            <div class="masonry-grid-tile-inner">
              <ng-container>
                <!-- <div class="masonry-grid-tile-image" style="background-image: url('{{ teaser.image.formats?.medium?.url }}');"></div>-->

                <div class="masonry-grid-tile-caption default-font-sizes default-font-sizes--very-big">
                  <p>{{ teaser.description }}</p>
                </div>
              </ng-container>

              <div class="masonry-grid-tile-caption">
                <img src="{{ teaser.image.formats?.medium?.url }}" alt="" />
              </div>
            </div>
          </div>
        </div>
      </ngx-masonry>
    </div>
  </section>
</ng-container>
